// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col-scale{position:relative}.col-scale .trigger{width:100%}.scale{margin:0;padding:0;line-height:normal}", ""]);
// Exports
module.exports = exports;
